import { FunctionComponent, useContext } from "react";

import { formStyles } from "@modules/acc/screens/claim/components/ClaimForm.styles.ts";
import { SubmissionForm } from "@ui-components/form/submission-form/SubmissionForm.tsx";

import { DischargeContext } from "../context/DischargeContext.ts";
import { ClaimDischargeFormValues } from "../types/dischargeFormValues.type.ts";
import { ClaimDischargeFormValidator } from "../validators/ClaimDischargeFormValidator.tsx";
import { ClaimDischargeFormLayout } from "./ClaimDischargeFormLayout.tsx";

export const ClaimDischargeForm: FunctionComponent = () => {
  const {
    initialValues,
    haveMultipleDisciplines,
    handleSubmitSucceeded,
    handleSubmitDischarge
  } = useContext(DischargeContext);

  const validator = new ClaimDischargeFormValidator(haveMultipleDisciplines);

  return (
    <SubmissionForm<ClaimDischargeFormValues>
      formName="claim-discharge"
      onSubmit={handleSubmitDischarge}
      onSubmitSucceeded={handleSubmitSucceeded}
      styles={formStyles}
      hideButtons
      initialValues={initialValues}
      validate={validator.validate}
    >
      {() => <ClaimDischargeFormLayout />}
    </SubmissionForm>
  );
};
